import { ChangeDetectorRef, Injectable, Optional } from "@angular/core";
import { FrameworkService } from "@core/framework/framework.service";
import { NavigatorService } from "@core/framework/navigator.service";
import { SysEventsService } from "@core/framework/sysevents.service";
import { SysEnumsService } from "@core/framework/sysenums.enum";
import { GenericListEndpoint } from "@core/endpoints/genericlist.endpoint";
import { SessionService } from '@core/framework/session.service';
import { ResourcesService } from '@core/framework/resources.service';
import { AppConfigService } from '@configuration/app.config.service';
import { CustomizationService } from '@core/framework/customization-service';
import { ScreenService } from '@m4u-angular/core/framework/screen.service';
import { UiService } from '@core/framework/ui.service';
import { RouteHistoryService } from '@m4u-angular/core/framework/route-history.service';
import { EntityService } from '@m4u-angular/core/framework/entity.service';
import { ShareService } from "@core/framework/share.service";

@Injectable()
export class ServiceBagService {
    Enums: any = {};
    constructor(
        public Framework: FrameworkService,
        @Optional() public ChangeDetector: ChangeDetectorRef,
        public GenericListEndpoint: GenericListEndpoint,
        public SysEnums: SysEnumsService,
        public Session: SessionService,
        public Navigator: NavigatorService,
        public SysEvents: SysEventsService,
        public ResourcesService: ResourcesService,
        public AppConfigService: AppConfigService,
        public CustomizationService: CustomizationService,
        public Screen: ScreenService,
        public UI: UiService,
        public RouteHistoryService: RouteHistoryService,
        public EntityService: EntityService,
        public ShareService: ShareService) {
        this.Enums = this.AppConfigService.AppConfig.Enums;
    }

}

export const ServiceBagServices =
    [
        ServiceBagService,
        NavigatorService
    ]
